<template>
    <ConfirmDialog />
	<div class="grid nested-grid">
		<div class="col-12">
			<div class="card fluid cardheader">
				<div class="col-12">
					<h5 class="stationsHeader">{{ componentTitle.toUpperCase() }}</h5>
				</div>												
			</div>	      

            <DataTable stateStorage="local" stateKey="dt-state-companies-session" :value="energysites" class="p-datatable-sm" removableSort :resizableColumns="true" showGridlines dataKey="id" 
            v-model:filters="filters1" :loading="loading1" responsiveLayout="scroll" :rowHover="true"
            :globalFilterFields="['Name','Street','City']"
            :paginator="true" :rows="10" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10,30,50]" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <template #header>
                        <div class="flex p-jc-end">
                            <span class="p-input-icon-right ">
                                <i class="pi pi-search" />
                                <InputText v-model="filters1['global'].value" :placeholder="translated('keywordsearch')" />
                            </span>
                        </div>
                    </template>        
                    <template #empty>
                        No companies found.
                    </template>
                    <template #loading>
                        Loading companies data. Please wait.
                    </template>    

                <Column field="IsOperator" :header="translated('cpotable')" dataType="boolean" bodyClass="p-text-center" >
                    <template #body="{data}">
                        <!-- <i v-if="data.IsOperator" class="pi" :class="'true-icon pi-check-circle'"></i> -->
                        {{ data.CpoId }}
                    </template>
                </Column>

                <Column field="IsServiceprovider" :header="translated('msptable')" dataType="boolean" bodyClass="p-text-center" >
                    <template #body="{data}">
                        <!-- <i v-if="data.IsServiceprovider" class="pi" :class="'true-icon pi-check-circle'"></i>        -->
                        {{ data.MspId }}             
                    </template>
                </Column>

                <Column field="IsRpo" :header="translated('rpotable')" dataType="boolean" bodyClass="p-text-center" >
                    <template #body="{data}">
                        <!-- <i v-if="data.IsRpo" class="pi" :class="'true-icon pi-check-circle'"></i> -->
                        {{ data.RpoId }}              
                    </template>
                </Column>

                <Column field="IsRsp" :header="translated('rsptable')" dataType="boolean" bodyClass="p-text-center" >
                    <template #body="{data}">
                        <!-- <i v-if="data.IsRsp" class="pi" :class="'true-icon pi-check-circle'"></i>   -->
                        {{ data.RspId }}                    
                    </template>
                </Column>

                <!-- <Column field="MspCpoApproved" :header="translated('codetable')" dataType="boolean" bodyClass="p-text-center" >
                    <template #body="{data}">
                        <i v-if="data.MspCpoApproved" class="codedefined pi" :class="'true-icon pi-check-circle'"></i>                    
                    </template>
                </Column>                 -->

                <Column :header="translated('companyname')" field="Name" :sortable="true" ></Column>

                <Column :header="translated('street')" >
                    <template #body="{data}">
                        {{ data.Street + ' ' + data.Housenumber}}                  
                    </template>            
                </Column>            

                <Column :header="translated('zipcity')" >
                    <template #body="{data}">
                        {{ (data.Zip == undefined ? '' : data.Zip)  + ' ' + (data.City==undefined ? '' : data.City)}}                  
                    </template>             
                </Column>
                <Column bodyStyle="text-align: center" headerStyle="width: 30px">
                    <template #body="slotProps">
                        <!-- viewcompanyid -->
                        <router-link :to="{ name: 'EnergySites', params: { viewcompanyid: slotProps.data.Id, viewedCompanName: slotProps.data.Name }}"> 
                            <Button icon="pi pi-th-large" class="p-button-raised p-button-rounded p-button-success buttonpolnilnice" />
                        </router-link>  
                        <router-link :to="{ name: 'CDashboard', params: { companyid: slotProps.data.Id }}"> 
                            <Button icon="pi pi-pencil" class="p-button-raised p-button-rounded p-button-secondary buttonpolnilnice" />
                            <!-- <Button icon="pi pi-pencil" class="p-button-raised p-button-rounded p-button-secondary" @click="goToDashboard(slotProps.data.Id)" /> -->
                        </router-link>   
                        
                        <router-link :disabled="isReadOnly" :to="{ name: 'DataConnections', params: { companyid: slotProps.data.Id }}"> 
                            <Button :disabled="isReadOnly" icon="pi pi-server" class="p-button-raised p-button-rounded p-button-secondary" />                            
                        </router-link>                          
                                
                        <!-- v-if="approved!=1"  -->
                        <Button :disabled="isReadOnly" icon="pi pi-trash" class="p-button-raised p-button-rounded p-button-warning brisicompany" @click="deleteCompany(slotProps.data)" />
                    </template>
                </Column>            
            </DataTable>
        </div>
    </div>  
</template>

<script>

import {FilterMatchMode,FilterOperator} from 'primevue/api';
import createHttp from "@/services/http";
import { computed } from "vue";
import store from "@/store";
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
// Approved: 0=nepotrjena, 1=potrjena, 2=brez kod
export default {
  props: ['approved'],  
  data() {
    return {
        translated: computed(() => store.getters.getTranslate),
        energysites : null,
        filters1: null,
        loading1: true
    }
  },
    computed: {
        componentTitle() {            
            const tmpNaslov = (this.approved==0) ? this.translated('newregistered') : (this.approved==1) ? this.translated('verifiedcompanies'): this.translated('podjetjebrezkodetitle');

            //console.log('Iščem naslov! : ' + tmpNaslov);
            //console.log(this.approved);
            return tmpNaslov;
        },
        isReadOnly() {
            return this.$store.getters.isInRole("ReadOnly");
        }
    },   
  created() {
      this.initFilters1();
  }, 
  beforeRouteUpdate(to, from, next) {
        /*
        console.log('BEFORE ENTER');
        console.log(to);
        console.log(from);
        console.log('approved:' + to.params.approved);
        */
    //   this.LoadData(to.params.approved);

      next();
    // called before the route that renders this component is confirmed.
    // does NOT have access to `this` component instance,
    // because it has not been created yet when this guard is called!
  },   
  async mounted() {           
      this.LoadData(this.approved);
  },
  methods: {

deleteCompany(companyObj) {
    this.$confirm.require({
      message: this.translated('deletecompanyquestion'),
      header:  this.translated('deletecompanytitle'),
      icon:    'pi pi-exclamation-triangle',
      acceptClass: 'p-button-danger',
      accept: async () => {
        // wait for the first dialog to un-mount
        await this.$nextTick();

        // now fire the second confirm, still closing over companyObj
        this.$confirm.require({
          message: this.translated('deletecompanyquestionLAST'),
          header:  this.translated('deletecompanytitleLAST'),
          icon:    'pi pi-exclamation-triangle',
          acceptClass: 'p-button-danger',
          accept:  async () => {
            try {
              const http = createHttp(true);
              const { status } = await http.delete(
                `${process.env.VUE_APP_API_FOLDER}/DeleteCompany?id=${companyObj.Id}`
              );

              if (status === 200) {
                await this.LoadData(this.approved);
                this.$toast.add({
                  severity: 'success',
                  summary:  'Confirmed',
                  detail:   'Record deleted',
                  life:     3000
                });
              } else {
                console.error('Delete failed with status', status);
              }
            }
            catch (err) {
              console.error(err);
            }
          },
          reject: () => {
            // nothing to do if they back out the second time
          }
        });
      },
      reject: () => {
        // first dialog was canceled
      }
    });
  },

        goToDashboard(id) {
            console.log('ID: ' + id);
            this.$router.push({ name: 'CDashboard', params: { companyid: id }});
        },

      clearFilter1() {
          this.initFilters1();
      },
      initFilters1() {
          this.filters1 = {
              'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
          }
      },
      async LoadData(isApproved) {
        const http = createHttp(true);
        const myUrl = process.env.VUE_APP_API_FOLDER + "/GetCompanies?approved=" + isApproved;
        console.log(myUrl);

        const result = await http.get(myUrl);
        //console.log('prejel nazaj:')
        //console.log(result)

        if(result.status==200){
            this.energysites = result.data
        }

        this.loading1 = false
    //console.log(this.energysites)
      }
  }  
}
</script>

<style scopd>
i.codedefined { color:#00d200 }
button.buttonpolnilnice { margin-right:5px; }
.brisicompany { margin-left:25px; }
/*
table.thead.tr.th:nth-child(1), table.thead.tr.th:nth-child(3), table.thead.tr.th:nth-child(3) { width: 10px; }
table.thead.tr.th:nth-child(4), table.thead.tr.th:nth-child(5) { width: auto; }
table.thead.tr.th:nth-child(6) { width: 200px; }
table.thead.tr.th:nth-child(7) { width: 30px; }
*/
</style>